import {
  GetRemoteDeviceListInput,
  IntegrationCustomerMappingInput,
  IntegrationProductMappingInput,
  IntegrationTaxMappingInput,
  UpdateIntegrationStatusInput,
} from "shared/types/integrations";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_INTEGRATION_BASE_URL;

export const getIntegrationSources = async (mine = false) => {
  try {
    // ?filter=my_integrations → backend returns only the sources the logged-in
    // user connected (created_by === req.auth user), so the FE does no matching.
    const url = `${BASE_URL}/v1/list/integration/sources${
      mine ? "?filter=my_integrations" : ""
    }`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      // return resData?.data?.result;
      return resData?.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const updateIntegrationStatus = async ({
  source,
  status,
}: UpdateIntegrationStatusInput) => {
  try {
    const url = `${BASE_URL}/${source}/msp/configuration/status/${status}`;
    const response = await axiosClient.patch(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const disconnectIntegration = async (source: string) => {
  try {
    const url = `${BASE_URL}/v1/${source}/disconnect`;
    const response = await axiosClient.post(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
export const getRemoteDevicesList = async ({
  customerUserId,
  sourceName,
}: GetRemoteDeviceListInput) => {
  try {
    const url = `${BASE_URL}/v1/list/customer-user/remote-devices/${customerUserId}/${sourceName}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getAllRemoteDevicesList = async ({
  customerUserId,
}: {
  customerUserId: string;
}) => {
  try {
    const url = `${BASE_URL}/v2/list/customer-user/remote-devices/${customerUserId}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
export const getIntegrationCustomers = async (source: string) => {
  try {
    // const url =
    //   source === "xero"
    //     ? `${BASE_URL}/v1/${source}/contacts`
    //     : `${BASE_URL}/${source}/list-customers`;
    const url = `${BASE_URL}/${source}/list-customers`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getIntegrationMappedCustomers = async (source: string) => {
  try {
    // const url =
    //   source === "xero"
    //     ? `${BASE_URL}/v1/xero/customer-mapping`
    //     : `${BASE_URL}/list/mapped-customers/${source}`;
    const url = `${BASE_URL}/list/mapped-customers/${source}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
  // console.log(response.data);
};

export const mapIntegrationCustomers = async ({
  customerData,
  source,
}: IntegrationCustomerMappingInput) => {
  try {
    const url = `${BASE_URL}/mapped-customers/${source}`;
    const data = {
      customers: customerData,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const mapIntegrationTax = async ({
  taxData,
  source,
}: IntegrationTaxMappingInput) => {
  try {
    const url = `${BASE_URL}/tax-mapping/${source}`;
    const data = {
      taxRates: taxData,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const mapIntegrationProduct = async ({
  products,
  source,
}: IntegrationProductMappingInput) => {
  try {
    const url = `${BASE_URL}/product-mapping/${source}`;
    const data = {
      products: products,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getIntegrationMappedProducts = async (source: string) => {
  try {
    const url = `${BASE_URL}/product-mapping/${source}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};

export const getIntegrationMappedTax = async (source: string) => {
  try {
    const url = `${BASE_URL}/tax-mapping/${source}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};
